import React, { FC } from 'react';
import { SubAccountType } from '../../../models/subaccount-type';
import { UserManagementType } from '../../../models/user-management-type';
import TableHeading from '../../atoms/table-heading/table-heading';
import UsersTableRow from '../users-table-row/users-table-row';

interface Props extends Partial<UserManagementType> {
  readonly onDeactivate?: (user: SubAccountType) => void;
  readonly onResend?: (user: SubAccountType) => void;
  readonly users: SubAccountType[];
}

const UsersTable: FC<Props> = (props: Props) => {
  const {
    onDeactivate,
    onResend,
    subUsersEmail,
    subUsersName,
    subUsersStatus,
    users,
  } = props;

  return (
    <table
      className="border-separate table-fixed w-full xl:w-4/5 mt-12 mx-auto"
      style={{ borderSpacing: 0 }}
    >
      <thead className="hidden lg:table-header-group">
        <tr>
          <TableHeading className="w-3/12" label={subUsersName} />
          <TableHeading className="w-4/12" label={subUsersEmail} />
          <TableHeading className="w-2/12" label={subUsersStatus} />
          <TableHeading label="" />
        </tr>
      </thead>

      <tbody>
        {users
          .filter((user) => !!user)
          .map((user: SubAccountType) => (
            <UsersTableRow
              key={user.userId}
              {...props}
              {...user}
              onDeactivate={() => onDeactivate(user)}
              onResend={() => onResend(user)}
            />
          ))}
      </tbody>
    </table>
  );
};

UsersTable.defaultProps = {
  onDeactivate: null,
  onResend: null,
};

export default UsersTable;
